import * as React from "react";
import { Spinner, SpinnerSize } from "@blueprintjs/core";   

const SecondaryContainer = (props) => {

    if(props.params.secondaryComponent){
        const secondaryComponent = props.params.secondaryComponent;
        // check if secondaryComponent is available in globalThis['bodaproComponents']
        if(!globalThis['bodaproComponents'][`${secondaryComponent}`]){
            return (
                <div className="p-2">
                    <Spinner size={SpinnerSize.LARGE}/>
                </div>
            );
        }
        const Component = globalThis['bodaproComponents'][`${props.params.secondaryComponent}`];
        
        return <Component {...props}/>
    }

    return (
        <div className="p-2">
            <Spinner size={SpinnerSize.LARGE}/>
        </div>
    );
}

export default SecondaryContainer;
